// ダウンロード統計を取得するユーティリティ
import { getFirestore, collection, getDocs } from 'firebase/firestore';

/**
 * 総ダウンロード数を取得（downloadsコレクションから）
 * @returns {Promise<number>} 総ダウンロード数
 */
export async function getTotalDownloads() {
  try {
    const db = getFirestore();
    const downloadsRef = collection(db, 'downloads');
    const snapshot = await getDocs(downloadsRef);
    return snapshot.size;
  } catch (error) {
    console.error('Failed to get download stats:', error);
    return 390; // フォールバック値
  }
}

/**
 * 直近7日間のダウンロード数を取得
 * @returns {Promise<number>} 直近7日間のダウンロード数
 */
export async function getWeeklyDownloads() {
  try {
    const db = getFirestore();
    const downloadsRef = collection(db, 'downloads');
    const snapshot = await getDocs(downloadsRef);

    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

    let weeklyCount = 0;
    snapshot.forEach(doc => {
      const data = doc.data();
      if (data.timestamp && data.timestamp.seconds) {
        const downloadDate = new Date(data.timestamp.seconds * 1000);
        if (downloadDate > sevenDaysAgo) {
          weeklyCount++;
        }
      }
    });

    return weeklyCount;
  } catch (error) {
    console.error('Failed to get weekly downloads:', error);
    return 200; // フォールバック値
  }
}

/**
 * ユニークユーザー数（企業・団体数）を取得
 * @returns {Promise<number>} ユニークユーザー数
 */
export async function getUniqueUsers() {
  try {
    const db = getFirestore();
    const downloadsRef = collection(db, 'downloads');
    const snapshot = await getDocs(downloadsRef);

    const uniqueEmails = new Set();
    snapshot.forEach(doc => {
      const data = doc.data();
      if (data.email) {
        uniqueEmails.add(data.email);
      }
    });

    return uniqueEmails.size;
  } catch (error) {
    console.error('Failed to get unique users:', error);
    return 95; // フォールバック値
  }
}

/**
 * 統計情報をまとめて取得
 * @returns {Promise<Object>} 統計情報オブジェクト
 */
export async function getStats() {
  const [totalDownloads, uniqueUsers] = await Promise.all([
    getTotalDownloads(),
    getUniqueUsers()
  ]);

  return {
    totalDownloads,
    uniqueUsers,
    publishedReports: 12, // 現在公開中のレポート数
    labArticles: 20 // 公開中のラボ記事数
  };
}
